(function () {
  var ARMED_KEY = 'tileApplicationPopupArmed';

  function getRoot() {
    return document.getElementById('tile-application-popup');
  }

  function showPanel(root, name) {
    root.querySelectorAll('[data-tap-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-tap-panel') !== name;
    });
  }

  function openPopup(root) {
    showPanel(root, 'intro');
    root.hidden = false;
    document.body.classList.add('tile-app-popup-open');
  }

  function closePopup(root) {
    root.hidden = true;
    document.body.classList.remove('tile-app-popup-open');
  }

  function createHubspotForm(root, container, attempt) {
    attempt = attempt || 0;

    if (typeof hbspt === 'undefined' || !hbspt.forms) {
      if (attempt >= 20) return;
      setTimeout(function () {
        createHubspotForm(root, container, attempt + 1);
      }, 250);
      return;
    }

    hbspt.forms.create({
      portalId: container.getAttribute('data-hubspot-portal-id'),
      formId: container.getAttribute('data-hubspot-form-id'),
      target: '#' + container.id,
      onFormSubmitted: function () {
        showPanel(root, 'thank-you');
      },
    });
  }

  function ensureHubspotForm(root) {
    var container = root.querySelector('#tile-app-popup-hubspot-form');
    if (!container || container.dataset.initialized === '1') return;
    container.dataset.initialized = '1';
    createHubspotForm(root, container);
  }

  function wireInteractions(root) {
    root.querySelectorAll('[data-tap-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(root);
      });
    });

    var showFormBtn = root.querySelector('[data-tap-show-form]');
    if (showFormBtn) {
      showFormBtn.addEventListener('click', function () {
        showPanel(root, 'form');
        ensureHubspotForm(root);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) closePopup(root);
    });
  }

  function isCartPage() {
    var cartPath = (window.routes && window.routes.cart_url) || '/cart';
    var normalize = function (p) {
      return p.replace(/\/+$/, '');
    };
    return normalize(window.location.pathname) === normalize(cartPath);
  }

  function evaluate(root) {
    if (!root) return;
    var shouldTrigger = root.getAttribute('data-should-trigger') === 'true';

    if (!shouldTrigger) {
      try {
        sessionStorage.removeItem(ARMED_KEY);
      } catch (e) {}
      return;
    }

    var count = parseInt(root.getAttribute('data-cart-count'), 10) || 0;

    if (isCartPage()) {
      try {
        sessionStorage.setItem(ARMED_KEY, String(count));
      } catch (e) {}
      openPopup(root);
      return;
    }

    var lastCount = 0;
    try {
      lastCount = parseInt(sessionStorage.getItem(ARMED_KEY), 10) || 0;
    } catch (e) {}

    try {
      sessionStorage.setItem(ARMED_KEY, String(count));
    } catch (e) {}

    // Only pop up again when items were added since the last time we looked.
    if (count > lastCount) openPopup(root);
  }

  function refreshSection() {
    fetch(window.routes.cart_url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = doc.getElementById('tile-application-popup');
        var oldRoot = getRoot();
        if (!newRoot || !oldRoot) return;

        var wasOpen = !oldRoot.hidden;
        oldRoot.replaceWith(newRoot);
        wireInteractions(newRoot);
        if (wasOpen) newRoot.hidden = false;

        evaluate(newRoot);
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = getRoot();
    if (!root) return;
    wireInteractions(root);

    if (isCartPage()) {
      evaluate(root);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        refreshSection();
      });
    }
  });
})();
